import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/ski-logo.svg'
import _imports_1 from '@/assets/hotel-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "ski-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_2 = {
  key: 0,
  style: {"margin":"0"}
}
const _hoisted_3 = {
  key: 1,
  style: {"margin":"0"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "hotel-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)

import store from '@/store'
import { computed, ref } from 'vue';
import PhotoBooth from './components/PhotoBooth.vue'
import CartDrawer from './components/CartDrawer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const scrolled = ref(false)

const currentUser = computed(() => store.getCurrentUser())

document.addEventListener('scroll', e => {
  scrolled.value = window.scrollY > 0
})

store.initialize()


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      style: _normalizeStyle(_ctx.$route.name != 'orders' && _unref(currentUser)?.registered ? 'padding-right:25.5rem' : ''),
      class: _normalizeClass({'scrolled': scrolled.value})
    }, [
      _hoisted_1,
      (_ctx.$route.name == 'orders')
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Bestellungen"))
        : (_unref(currentUser)?.registered)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "Hallo " + _toDisplayString(_unref(currentUser).name) + "!", 1))
          : _createCommentVNode("", true),
      _hoisted_4
    ], 6),
    _createElementVNode("main", {
      style: _normalizeStyle(_ctx.$route.name != 'orders' && _unref(currentUser)?.registered ? 'padding-right:24rem' : '')
    }, [
      _createVNode(_component_router_view)
    ], 4),
    _createVNode(PhotoBooth, { countdown: 10 }),
    (_ctx.$route.name != 'orders' && _unref(currentUser)?.registered)
      ? (_openBlock(), _createBlock(CartDrawer, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})